<template>
  <div
    class="mb-2 flex flex-wrap items-center gap-2 rounded border border-blue-100/50 bg-refonte-pale-violet-2 px-4 py-3 text-sm text-blue-800">
    <div class="w-full text-black">
      <template v-if="!props.signataire_unique">
        <div class="flex w-full">
          <div class="info-icon shrink-0 text-refonte_blue-600">
            <IconInformation />
          </div>
          <div class="mb-3 text-blue-800">
            La procédure de signature du Protocole Individuel de Formation
            s'effectue en
            <strong class="text-slate-800 font-semibold"
              >deux étapes consécutives</strong
            >
            :
          </div>
        </div>
        <ul
          class="marker:text-slate-400 mb-4 mt-0 list-disc space-y-1.5 pl-10 text-blue-800">
          <li>
            <strong class="font-semibold">Étape 1 :</strong> Vous désignez
            ci-dessous le signataire représentant le cabinet.
          </li>
          <li>
            <strong class="font-semibold">Étape 2 :</strong> Une fois le
            document signé par le cabinet, le participant recevra
            automatiquement une invitation pour contresigner.
          </li>
        </ul>
        <div
          class="mt-3 flex rounded-lg border border-amber-100 bg-amber-50 p-3.5 shadow-sm">
          <span class="info-icon mt-0.5 shrink-0 text-amber-600">
            <IconShield />
          </span>
          <div class="space-y-1.5 text-amber-800">
            <p class="leading-relaxed">
              <strong class="font-bold">Prérequis :</strong> Les deux
              signataires doivent avoir un
              <strong class="font-bold">numéro de mobile valide</strong>
              renseigné sur la page
              <strong>Mes informations personnelles</strong> sur leur espace
              Jinius - Ce numéro n'est pas utilisé à des fins commerciales.
            </p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex w-full">
          <div class="info-icon shrink-0 text-refonte_blue-600">
            <IconInformation />
          </div>
          <div class="mb-3 text-blue-800">
            Le signataire représentant le cabinet étant également le
            participant, la procédure de signature est simplifiée :
          </div>
        </div>
        <ul
          class="marker:text-slate-400 mb-4 mt-0 list-disc space-y-1.5 pl-10 text-blue-800">
          <li>
            Vous ne recevrez qu'<strong class="font-semibold"
              >une seule invitation </strong
            >par e-mail.
          </li>
          <li>
            Votre signature électronique sera
            <strong class="font-semibold">automatiquement apposée </strong>dans
            les deux encarts (cabinet et participant) prévus sur le document.
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconInformation from '@/assets/img/refonte/icons/information/icon-information.svg?component';
  import IconShield from '@/assets/img/refonte/icons/information/icon-shield.svg?component';

  const props = withDefaults(
    defineProps<{
      signataire_unique?: boolean;
    }>(),
    {}
  );
</script>

<style lang="scss" scoped>
  .info-icon {
    @apply mr-2 flex shrink-0 items-center justify-center;
    width: 16px;
    height: 16px;

    :deep(svg) {
      width: 16px;
      height: 16px;
    }
  }
</style>
